// hooks/useCotaUsuario.ts
import { useState, useEffect } from "react";
import { empreendimentoUsuarioService } from "../services/empreendimentoUsuarioService";
import { Empreendimento } from "../interfaces/Empreendimento";

export const useEmpreendimentoUsuario = (
  empreendId: number | undefined,
  fetch: boolean
) => {
  const [isLoading, setIsLoading] = useState(true);
  const [empreendimentoUsuario, setEmpreendimentoUsuario] = useState<
    Empreendimento | undefined
  >(undefined);

  useEffect(() => {
    const fetchEmpreendimentoUsuario = async () => {
      if (empreendId && fetch) {
        setIsLoading(true);
        try {
          const data = await empreendimentoUsuarioService(empreendId);
          if (data) {
            setEmpreendimentoUsuario(data);
          } else {
            console.error(
              "Dados não encontrados para o empreendimento do usuário"
            );
          }
        } catch (error) {
          console.error("Erro ao buscar emprendimento:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchEmpreendimentoUsuario();
  }, [empreendId, fetch]); // Dependência de usuarioId e fetch para garantir que a chamada seja feita quando necessário

  return { isLoading, empreendimentoUsuario };
};
